/* This example requires Tailwind CSS v2.0+ */
import { time, usura } from "../../utils/TMLV";
import { Home } from "../../components/backgrounds/Home";

let Tmlv;
let _time;
let _usura;

try {
  Tmlv = JSON.parse(localStorage.getItem("tmlv") ?? "{}");
  _time = Tmlv[0]?.date ?? "";
  _usura = `${Tmlv[0]?.rate}${Tmlv[0]?.percent} ${Tmlv[0]?.text}`;
} catch (error) {
  console.log(error);
  _time = time;
  _usura = usura;
}

const rates = [
  {
    title: "Tasa de interés corriente",
    /* value:`${parseInt(Tmlv[0]?.rate) < 25 ? Tmlv[0]?.rate : 25}% E.A`, */
    value:`Tasa Máxima legal permitida`,
  },
  {
    title: "Tasa de interés moratorio",
    value: "Tasa máxima legal permitida",
  },
  {
    title: "Firma electrónica (Opcional: Puede tener descuentos por pronto pago)",
    value: "$145.000",
  },
  {
    title: "Gastos de cobranza",
    value: "Se causan sólo si entras en estado de mora y se liquida de acuerdo a la gestión desplegada",
  },
];

const tasaTitle = `Tasa máxima legal permitida para ${_time} ${_usura}`;

export function RatesPage() {
  return (
    <>
      <Home
        title={"Sin costos ocultos ni letra pequeña"}
        description={
          "En Galilea te explicamos con transparencia los costos asociados a tu crédito"
        }
      />
      <main>
        <div className="bg-purpleLight">
          <div className="py-20 text-center">
            <div className="font-bold text-3xl">Tasas y tarifas vigentes</div>
            <div className="w-full flex justify-center pt-8">
              <div className="bg-darkBgLight text-white w-full max-w-2xl rounded-3xl text-left">
                <div className="bg-darkBg rounded-t-3xl py-4 px-8">
                  <div>
                    <div className="block font-bold text-lg">Crédito de bajo monto</div>
                    <div> {tasaTitle} </div>
                  </div>
                </div>
                {rates.map((rate) => (
                  <div key={rate.title} className="flex justify-between gap-2 w-full px-8 py-4 border-t border-tdark">
                    <div className="w-full">{rate.title}</div>
                    <div className="w-full text-right">{rate.value}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

/* This example requires Tailwind CSS v2.0+ */
